import React from "react";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { PenLine, Zap } from "lucide-react";

const MAX = 1000;

export const CustomEditBox = ({ action, value, onChange, onSubmit, disabled }) => {
  if (!action) return null;
  const ready = value.trim().length >= 3;
  return (
    <div className="rounded-xl border border-fuchsia-500/25 bg-[#15131C] p-3 space-y-2.5" data-testid="custom-edit-box">
      <div className="flex items-center justify-between gap-2">
        <span className="flex items-center gap-2 text-sm font-medium text-white">
          <PenLine className="w-4 h-4 text-fuchsia-300" /> {action.label}
        </span>
        <span className="text-[10px] font-semibold text-cyan-300 flex items-center gap-0.5" data-testid="custom-edit-cost">
          <Zap className="w-2.5 h-2.5" />{action.cost}
        </span>
      </div>
      <Textarea
        value={value}
        maxLength={MAX}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        rows={3}
        placeholder="Ej.: pinta la pared del fondo de verde salvia y quita la lámpara de pie"
        data-testid="custom-edit-input"
        className="bg-black/30 border-white/10 text-sm text-white placeholder:text-slate-500 resize-none"
      />
      <div className="flex items-center justify-between gap-2">
        <span className="text-[10px] text-slate-500 tabular-nums">{value.length}/{MAX}</span>
        <Button size="sm" disabled={disabled || !ready} onClick={onSubmit} data-testid="custom-edit-submit"
          className="rounded-full bg-gradient-to-r from-fuchsia-600 to-cyan-500 hover:brightness-110 text-white font-semibold transition-[filter]">
          Aplicar con IA
        </Button>
      </div>
    </div>
  );
};
